<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<style lang="less">
</style>
<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="less">
div {
  font-size: 15px;
}

.grey-box {
  background-color: #f7f8fa;
  min-height: 100vh;
}
.van-cell-group {
  margin: 0 12px 0;
  overflow: hidden;
  border-radius: 8px;
}
.ql-editor {
  min-height: 100px !important;
}
</style>